import windowLoad from '../events/window-load'

export default (function() {
  'use strict';

  let comparisonBlocks = []
  let eventHandlers = []

  function init() {

    // Remove previous event handlers
    comparisonBlocks.forEach(function(comparisonBlock, i) {
      Object.keys(eventHandlers[i]).forEach((eventHandlerKey) => {
        comparisonBlock.removeEventListener(eventHandlers[i][eventHandlerKey])
      })
    })

    comparisonBlocks = Array.from(document.querySelectorAll('.content-comparison-block'))
    eventHandlers = []

    comparisonBlocks.forEach(function(comparisonBlock) {
      (function(block) {
        let after = block.querySelector('.comparison-after');
        let down = false

        let mouseHandlers = {
          mousedown: function(e) {
            down = true
          },
          mousemove: function(e) {
            if (down) {
              after.style.width = `${e.pageX}px`
            }
          },
          mouseup: function(e) {
            down = false
          },
          touchstart: function(e) {
            down = true
          },
          touchmove: function(e) {
            if (down) {
              after.style.width = `${e.pageX}px`
            }
          },
          touchend: function(e) {
            down = false
          }
        }

        eventHandlers.push(mouseHandlers)

        Object.keys(mouseHandlers).forEach((eventHandlerKey) => {
          block.addEventListener(eventHandlerKey, mouseHandlers[eventHandlerKey])
        })


        // block.addEventListener('mousedown', mouseHandlers.mouseDown)
        // block.addEventListener('mousemove', mouseHandlers.mouseMove)
        // block.addEventListener('mouseup', mouseHandlers.mouseUp)
      })(comparisonBlock);
    })
  }

  return {
    init: init
  };

})();
